import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/providers/ThemeProvider";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
      className={`relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#E3F5EA] dark:border-[#1A3925] bg-white dark:bg-[#12331E] text-[#0E2A17] dark:text-[#F2FAF4] hover:bg-[#E3F5EA] dark:hover:bg-[#1A3925] transition-colors ${className}`}
    >
      <Sun
        className={`h-4 w-4 transition-all ${
          isDark ? "opacity-0 -rotate-90 scale-0" : "opacity-100 rotate-0 scale-100"
        }`}
      />
      <Moon
        className={`absolute h-4 w-4 transition-all ${
          isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 rotate-90 scale-0"
        }`}
      />
    </button>
  );
}
